import { Button, FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { useFormik } from 'formik';
import { useMutation, useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getBannerByIdFn, getCategoryFn, getSubCategoryFn, getsubSubCategoryFn, patchBannerFn, postBannerFn } from 'Services/Banner';
import CustomInput from 'Shared/CustomInput';
import CustomSelect from 'Shared/CustomSelect';
import ImageInput from 'Shared/ImageInput';
import RichTextEditor from 'Shared/RichTextEditory';

const AddUpdateBanner = () => {
    const navigate = useNavigate();
    const { id, status } = useParams();

    const { data: getBannerIdResponse } = useQuery({
        queryKey: ['get-banner-by-id', id, status],
        queryFn: () => getBannerByIdFn(id),
        enabled: !!id && status === "update"
    })
    const data = getBannerIdResponse?.data?.data;

    const { mutate: post } = useMutation(postBannerFn, {
        onSuccess: (response) => {
            toast.success(response?.data?.message);
            navigate('/banner')
        },
        onError: (error) => {
            toast.error("Failed to Add Banner");
        }
    })

    const { mutate: patch } = useMutation(patchBannerFn, {
        onSuccess: (response) => {
            toast.success(response?.data?.message);
            navigate('/banner')
        },
        onError: (error) => {
            toast.error("Failed to Update Banner");
        }
    })

    const initialValues = {
        image: "",
        description: data?.description || "",
        link: data?.link || "",
        category: data?.category || "",
        subcategory: data?.subcategory || null,
        subsubcategory: data?.subsubcategory || null
    }

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        onSubmit: (values) => {
            const formData = new FormData();
            formData.append('description', values.description);
            formData.append('link', values.link);
            if (values?.category) formData.append("category", values?.category)
            if (values?.subcategory) formData.append("subcategory", values?.subcategory)
            if (values?.subsubcategory) formData.append("subsubcategory", values?.subsubcategory)

            if (status === 'add') {
                if (!values.image) return toast.error('Image is required.')
                formData.append("image", values.image);
                post(formData);
            } else {
                if (values.image) formData.append("image", values.image)
                formData.append("banner_id", id);
                patch(formData);
            }
        }
    });


    const { data: CategoryData } = useQuery(["category"], () => getCategoryFn())

    const { data: SubCategoryData } = useQuery(["subcategory"], () => getSubCategoryFn())

    const { data: subSubCategoryData } = useQuery(["subsubcategory"], () => getsubSubCategoryFn())

    console.log(subSubCategoryData, "whdoiwdbi")
    return (
        <div>
            <form
                className="bg-white shadow-md rounded-lg mx-auto p-4 flex flex-col gap-6"
                onSubmit={formik.handleSubmit}
            >
                <p className="text-xl !text-black font font-bold text-center">
                    {status === "update" ? "Update" : "Add"} Banner
                </p>
                <FormControl fullWidth margin="normal" error={Boolean(formik.touched.category && formik.errors.category)}>
                    {/* <InputLabel id="category-label">Select Category</InputLabel> */}
                    <Select
                        labelId="category-label"
                        id="category"
                        name="category"
                        value={formik.values.category}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        displayEmpty
                        size='small'
                    >
                        <MenuItem value="" disabled>
                            Select Category
                        </MenuItem>

                        {CategoryData?.data?.data?.map((i) => (
                            <MenuItem key={i?.id} value={i?.id}>
                                {i?.title}
                            </MenuItem>
                        ))}
                    </Select>

                    {formik.touched.category && formik.errors.category && (
                        <FormHelperText>{formik.errors.category}</FormHelperText>
                    )}
                </FormControl>


                <FormControl
                    fullWidth
                    margin="normal"
                    error={Boolean(formik.touched.subcategory && formik.errors.subcategory)}
                >
                    <Select
                        id="subcategory"
                        name="subcategory"
                        value={formik.values.subcategory}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        displayEmpty
                        size="small"
                        renderValue={(selected) => {
                            if (!selected) {
                                return <span className="text-gray-400">Select Sub Category</span>;
                            }
                            const item = SubCategoryData?.data?.data?.find((i) => i.id === selected);
                            return item?.title || selected;
                        }}
                    >
                        <MenuItem value="" disabled>
                            Select Sub Category
                        </MenuItem>

                        {SubCategoryData?.data?.data?.map((i) => (
                            <MenuItem key={i?.id} value={i?.id}>
                                {i?.title}
                            </MenuItem>
                        ))}
                    </Select>

                    {formik.touched.subcategory && formik.errors.subcategory && (
                        <FormHelperText>{formik.errors.subcategory}</FormHelperText>
                    )}
                </FormControl>

                <FormControl
                    fullWidth
                    margin="normal"
                    error={Boolean(formik.touched.subsubcategory && formik.errors.subsubcategory)}
                >
                    <Select
                        id="subsubcategory"
                        name="subsubcategory"
                        value={formik.values.subsubcategory}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        displayEmpty
                        size="small"
                        renderValue={(selected) => {
                            if (!selected) {
                                return <span className="text-gray-400">Select Sub Category</span>;
                            }
                            const item = subSubCategoryData?.data?.data?.subsubcategories?.find((i) => i.id === selected);
                            return item?.title || selected;
                        }}
                    >
                        <MenuItem value="" disabled>
                            Select Sub Category
                        </MenuItem>

                        {subSubCategoryData?.data?.data?.subsubcategories?.map((i) => (
                            <MenuItem key={i?.id} value={i?.id}>
                                {i?.title}
                            </MenuItem>
                        ))}
                    </Select>

                    {formik.touched.subcategory && formik.errors.subcategory && (
                        <FormHelperText>{formik.errors.subcategory}</FormHelperText>
                    )}
                </FormControl>


                <CustomInput formik={formik} label={"Link"} name={"link"} />
                <ImageInput formik={formik} label={"Image"} name={'image'} />
                <RichTextEditor formik={formik} label={"description"} name={"description"} />
                <Button
                    type='submit'
                    variant='contained'
                >
                    {status === "update" ? "Update" : "Add"}
                </Button>
            </form>
        </div>
    )
}

export default AddUpdateBanner;